export const FETCH_VIRTUAL_POS_TERMINALS_STARTED = "FETCH_VIRTUAL_POS_TERMINALS_STARTED";
export const FETCH_VIRTUAL_POS_TERMINALS_SUCCEEDED = "FETCH_VIRTUAL_POS_TERMINALS_SUCCEEDED";
export const FETCH_VIRTUAL_POS_TERMINALS_FAILED = "FETCH_VIRTUAL_POS_TERMINALS_FAILED"

export const FETCH_HARDWARE_POS_TERMINALS_STARTED = "FETCH_HARDWARE_POS_TERMINALS_STARTED";
export const FETCH_HARDWARE_POS_TERMINALS_SUCCEEDED = "FETCH_HARDWARE_POS_TERMINALS_SUCCEEDED";
export const FETCH_HARDWARE_POS_TERMINALS_FAILED = "FETCH_HARDWARE_POS_TERMINALS_FAILED"

export const FETCH_HARDWARE_POS_REQUESTS_STARTED = "FETCH_HARDWARE_POS_REQUESTS_STARTED";
export const FETCH_HARDWARE_POS_REQUESTS_SUCCEEDED = "FETCH_HARDWARE_POS_REQUESTS_SUCCEEDED";
export const FETCH_HARDWARE_POS_REQUESTS_FAILED = "FETCH_HARDWARE_POS_REQUESTS_FAILED"

export const FETCH_SWEEP_HISTORY_STARTED = "FETCH_SWEEP_HISTORY_STARTED";
export const FETCH_SWEEP_HISTORY_SUCCEEDED = "FETCH_SWEEP_HISTORY_SUCCEEDED";
export const FETCH_SWEEP_HISTORY_FAILED = "FETCH_SWEEP_HISTORY_FAILED"

export const CHECK_POS_ONBOARDING_STATUS_STARTED = "CHECK_POS_ONBOARDING_STATUS_STARTED";
export const CHECK_POS_ONBOARDING_STATUS_SUCCEEDED = "CHECK_POS_ONBOARDING_STATUS_SUCCEEDED";
export const CHECK_POS_ONBOARDING_STATUS_FAILED = "CHECK_POS_ONBOARDING_STATUS_FAILED"
